module.exports = __webpack_public_path__ + "img/roadmap.da8ba2b6.png";